// same server as the screens, so the app works on any domain (local, the current server, your own server)
export const systemUrl = '/api/rest/';

// Calls api/rest.php. Returns the JSON answer, or false when the server could not be reached.
const fetchData = async (postData) => {
    try {
        const url = systemUrl + postData.action + '?token=' + (postData.token || '');

        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: { 'Content-Type': 'application/json' },
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });

        const result = await response.json();

        // signed out (session expired, user blocked, or signed in on another device after a password change)
        if (result && result.auth === 0 && postData.action !== 'login') {
            localStorage.setItem('user', '{}');
            window.location.hash = '#/login';
            return false;
        }

        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        return false;
    }
};

export default fetchData;
